import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../api"; 
import toastMessages from "../../helpers/toastMessage"; 
import { useOktaAuth } from "@okta/okta-react"; 
import { AxiosError } from "axios";

function useCancelPickup(setCancelling: (value: boolean) => void) {
  const authState = useOktaAuth()?.authState;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["cancelPickup"],
    mutationFn: (id: number) => {
      setCancelling(true);
      return axiosInstance.put(
        `v1/fedex/cancel-pickup/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        }
      );
    },
    onSuccess: (response: any) => {
      toastMessages.success(response?.data?.message);
      setCancelling(false);
      queryClient.invalidateQueries({ queryKey: ["pickupList"] });
    },
    onError: (error: AxiosError<any, any>) => {
      toastMessages.error(error.message);
      setCancelling(false);
    },
  });
}

export default useCancelPickup;
